import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpNews = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){
        let mpSwiperNews = new Swiper($(this.$el).find('.js-news-slider')[0], {
            loop: true,
            lazyPreloadPrevNext: 2, // соседи видимых: Swiper снимает loading у их картинок — сигнал модулю lazyload.js
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 30,
            // autoplay: {
            //   delay: 3000
            // },
            navigation: {
              nextEl: ".js-news-next",
              prevEl: ".js-news-prev"
            },
            breakpoints: {
              320: {
                slidesPerView: 1.23,
                spaceBetween: 8
              },
              576: {
                slidesPerView: 2,
                spaceBetween: 15
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 30
              }
            }
        });
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section news__mp">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Новости и события
                </h2>
                <div class="section__nav-arrows">
                    <div class="swiper-button-prev slider-btn js-news-prev">
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                    </div>
                    <div class="swiper-button-next slider-btn js-news-next">
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                </div>
            </div>
            <div class="section__nav">
                <a :href="this.struct[this.structKey].componentData.LIST_PAGE_URL" class="section__nav-link">
                    Все
                    <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                </a>
            </div>
        </div>
        <div class="swiper news__mp-slider js-news-slider">
            <div class="swiper-wrapper">
                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" :key="item.ID" class="swiper-slide">
                    <div class="news__item">
                        <a :href="item.LINK" class="news__item-img" :class="{'no-photo': item.PICTURE === false}">
                            <img v-if="item.PICTURE !== false" class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME" loading="lazy">
                            <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                        </a>
                        <div class="news__item-info">
                            <div class="news__item-date">
                                <div v-if="item.DATE !== false" class="news__item-date-leftside">
                                    <span>{{item.DATE.day}}</span>
                                    {{item.DATE.month}}
                                </div>
                                <div v-if="item.DATE !== false" class="news__item-date-year">
                                    ‘{{item.DATE.year}}
                                </div>
                            </div>
                            <a :href="item.LINK" class="news__item-name" v-html="item.NAME">
                            </a>
                            <div class="news__item-desc" v-html="item.TEXT">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    `
}